<div class="grid fill-vert">
  <div class="col-4 p-2">
    <app-phi-summary header="MEMBER/PATIENT"
      [phi]="currentMember"
      [editablePhi]="true"
      (optOutStatusChange)="toggleOptOut($event)"
      (currentMemberChange)="currentMemberChanged($event)"
      [loggedInUser]="loggedInUser"
      [wlpPhoneNumber]="wlpPhoneNumber">
    </app-phi-summary>
    <app-plan-summary [phi]="currentMember" (phiChange)="currentMemberChanged($event)"></app-plan-summary>
  </div>

  <div class="col-4 p-2">

    <app-eob-summary [phi]="currentMember"></app-eob-summary>

  </div>

  <div class="col-4 p-2">
    <!-- Online profile linker -->
    <app-b2cuser-list [phi]="currentMember"></app-b2cuser-list>
    <!-- Notes and diaries -->
    <p-accordion class="fill-vert">
      <!--
      <p-accordionTab header="Diaries">
        <div style="height:500px">
          <app-diary-scroller [getForCurrentUser]="false" [referenceCode]=2 [relatedTo]="currentMember.phiId" rowBufferLen="5" [allowNew]="true" ></app-diary-scroller>
        </div>
      </p-accordionTab>
      -->
      <p-accordionTab header="Notes">
        <div style="height:500px">
          <app-note-scroller [referenceCode]="notesRefCode" [relatedTo]="currentMember.phiId" rowBufferLen="5" ></app-note-scroller>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>

</div>


